import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import logo from '../../images/my_btn_mb_w.png';
import Pagenation from 'components/Pagenation';
import { useAppContext } from 'utils/store';
import * as fireonApi from "../../apis/FireOnApi";
import { apiWrapper } from 'apis/CommonApi';

export default function UserStatusComponent(props) {
    return (
        <>
            <div className="viewBoard fireOnBoard tableBoard BDtableBoard">
                <TopBoard header={props.header} />
                <MidColumnBoard />
                <TableBoard />
                <BottomBoard />
            </div>
        </>
    );
}

const TopBoard = ({ header }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { buildingName } = location.state;

    const handleGoBack = () => {
        navigate(-1);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo"> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <Link className="set_contr" to="">
                            <img src={logo} alt="" />
                        </Link>
                    </div>
                </div>
            </div>

            <div className="top_board navi_board">
                <div className="wrap_navi">
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p className="title_navi">{buildingName}</p>
                </div>
                {header}
                <div className="wrap_right mb">
                    <Link className="btn_page_left" to="/buildingDetail_mb.html">
                        <i className="x-icon"></i>
                    </Link>
                </div>
            </div>
        </>
    );
};

const MidColumnBoard = () => {
    let { id } = useParams();
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    return (
        <div className="mid_board mid_col_board">
            <div className="wrap_mid_le">
                <div className="wrap_item_contr">
                    <div className="building_info">
                        <div className="item_info">
                            <p className="txt_info title_info">일련번호</p>
                            <p className="txt_info code_info">{serialNumber}</p>
                        </div>
                        <div className="item_info">
                            <p className="txt_info title_info">DEI 코드</p>
                            <p className="txt_info code_info">{dei}</p>
                        </div>
                    </div>
                </div>
                <div className="wrap_item_contr">
                    <Link
                        className="btn_contr btn_new"
                        to={`/fire-on/new/${id}`}
                        state={{
                            buildingName: buildingName,
                            serialNumber: serialNumber,
                            dei: dei,
                        }}
                    >
                        건축물 일반 현황
                    </Link>
                    <Link
                        className="btn_contr btn_new"
                        to={`/fire-on/building-detail-status/${id}`}
                        state={{
                            buildingName: buildingName,
                            serialNumber: serialNumber,
                            dei: dei,
                        }}
                    >
                        건축물 상세 현황
                    </Link>
                    <Link
                        className="btn_contr btn_new"
                        to={`/fire-on/building-equipment-status/${id}`}
                        state={{
                            buildingName: buildingName,
                            serialNumber: serialNumber,
                            dei: dei,
                        }}
                    >
                        소방설비 등록 현황
                    </Link>
                    <button
                        className="btn_contr btn_new active"
                    >
                        사용자 등록 현황
                    </button>
                </div>
            </div>
            <div className="wrap_right">
                <div className="wrap_item_contr">
                    <div className="wrap_search pc">
                        <div className="box_search">
                            <div className="select_box">
                                <button className="btn_select">
                                    <p>항목</p>
                                    <i className="x-icon"></i>
                                </button>
                                <ul className="list_member">
                                    <li><p>1</p></li>
                                    <li><p>2</p></li>
                                    <li><p>3</p></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TableBoard = () => {
    const { id } = useParams();
    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        apiWrapper(async () => {
            const { status, data } = await fireonApi.getFireFightingObjectUsers(id);
            if (status === true) {
                setDataSource(data);
            } else {
                alert(`${data}`);
            }
        });
    }

    const handleChangeAccessPermission = (e, userId, userName) => {
        const name = e.target.name;
        const value = e.target.value;

        console.log(id, userId, value);
        if (window.confirm(`${userName} 님의 접속권한을 변경하시겠습니까?`)) {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.setFireFightingObjectUserAccessPermission(id, userId, value);
                alert(`${data}`);

                //설정 성공 시 새로고침
                if (status === true) {
                    getData();
                }
            });
        }
    }

    const handleChangePrimaryManager = (userId, userName) => {
        if (window.confirm(`${userName} 님을 대표관리자로 설정하시겠습니까?\n기존 대표관리자는 자동 해제됩니다.`)) {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.setFireFightingObjectUserPrimaryManager(id, userId);
                alert(`${data}`);

                //설정 성공 시 새로고침
                if (status === true) {
                    getData();
                }
            });
        }
    }

    return (
        <div className="table_board scroll_board">
            <div className="wrap_table part_table">
                <p class="title_table">사용자 등록 현황</p>
                <div className="containerTable buildingDetailTable">
                    <ul className="head_table">
                        <li><p>구분</p></li>
                        <li><p>성명</p></li>
                        <li><p>직함/직책</p></li>
                        <li><p>연락처</p></li>
                        <li><p>이메일</p></li>
                        <li><p>ID</p></li>
                        <li><p>접속여부</p></li>
                        <li><p>대표관리자</p></li>
                    </ul>

                    <div className="body_table">
                        <div className="inner_table_wrap">
                            {dataSource.length > 0 &&
                                dataSource.map((item, index) => {
                                    const useNestedRow = index < dataSource.length - 1 && item.userType === dataSource[index + 1].userType;
                                    const WrapperComponent = useNestedRow ? NestedRow : TableRow;
                                    return (
                                        <WrapperComponent>
                                            <Row
                                                index={index}
                                                id={item.id}
                                                userType={item.userType}
                                                name={item.name}
                                                title={item.title}
                                                contact={item.contact}
                                                email={item.email}
                                                userId={item.userId}
                                                accessPermission={item.accessPermission}
                                                isPrimaryManager={item.isPrimaryManager}
                                                handleChangeAccessPermission={handleChangeAccessPermission}
                                                handleChangePrimaryManager={handleChangePrimaryManager}
                                            />
                                        </WrapperComponent>
                                    );
                                })}
                        </div>
                    </div>

                    {/* 접속허용/차단, 대표관리자 설정/해제 클릭 시 바로 적용
                    <div className="wrap_controll type-start type-black">                         
                        <div className="wrap_btn_set">
                            <button className="btn_set btn_cancle">취소</button>
                            <button className="btn_set btn_save">저장</button>
                        </div> 
                        <div id="pagination">
                            <Pagenation />
                        </div>                    
                    </div>
                    */}
                </div>
            </div>
        </div >
    );
};

const TableRow = ({ children }) => {
    return (
        <div class="wrap_table_item">
            {children}
        </div>
    );
};

const NestedRow = ({ children }) => {
    return (
        <div class="wrap_table_item wrap_dept_tabel_item">
            <div class="wrap_dept_inner">
                {children}
            </div>
        </div>
    );
};

const Row = ({ id, userType, name, title, contact, email, userId, accessPermission, isPrimaryManager, handleChangeAccessPermission, handleChangePrimaryManager }) => {
    return (
        <>
            <div className="inner_table_item table_item_01">
                <p className="cont_table_item">{userType}</p>
            </div>
            <div className="inner_table_item table_item_02">
                <p className="cont_table_item">{name}</p>
            </div>
            <div className="inner_table_item table_item_03">
                <p className="cont_table_item">{title}</p>
            </div>
            <div className="inner_table_item table_item_04">
                <p className="cont_table_item">{contact}</p>
            </div>
            <div className="inner_table_item table_item_05">
                <p className="cont_table_item">{email}</p>
            </div>
            <div className="inner_table_item table_item_06">
                <p className="cont_table_item">{userId}</p>
            </div>
            <div className="inner_table_item table_item_07">
                <div class="cont_table_item">
                    <div class="access-radio-group">
                        <label class="access-radio">
                            <input type="radio" value="true" checked={accessPermission.toString() === "true"} onChange={(e) => handleChangeAccessPermission(e, id, name)} />
                            <span class="radio-label">접속허용</span>
                        </label>
                        <label class="access-radio">
                            <input type="radio" value="false" checked={accessPermission.toString() === "false"} onChange={(e) => handleChangeAccessPermission(e, id, name)} />
                            <span class="radio-label">접속차단</span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="inner_table_item table_item_08">
                {isPrimaryManager.toString() === "true" ?
                    <p className="cont_table_item">대표관리자</p>
                    :
                    <div className="cont_table_item">
                        <div class="access-radio-group">
                            <label class="access-radio">
                                <input type="radio" value="true" checked onClick={() => handleChangePrimaryManager(id, name)} />
                                <span class="radio-label">설정</span>
                            </label>
                        </div>
                    </div>
                }
            </div >
        </>
    );
};

const BottomBoard = () => {
    const { id } = useParams();
    const [businessName, setBusinessName] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        apiWrapper(async () => {
            const { status, data } = await fireonApi.getFireFightingObjectBusinessUser(id);
            if (status === true) {
                setBusinessName(data.businessName);
            } else {
                alert(`${data}`);
            }
        })
    }

    const openModal = () => {
        setIsModalOpen(true);
        setTimeout(() => {
            const modalContent = document.querySelector(".modal_content");
            if (modalContent) {
                modalContent.style.transform = "translateX(0)";
            }
        }, 10);
    }

    const closeModal = () => {
        const modalContent = document.querySelector(".modal_content");
        if (modalContent) {
            modalContent.style.transform = "translateX(100%)";
        }
        setTimeout(() => {
            setIsModalOpen(false);
        }, 500);
    }

    return (
        <>
            <div className="table_board">
                <div className="wrap_table part_table">
                    <p class="title_table">모니터링 관리 사업자</p>
                    <div className="wrap_item_contr">
                        <div className="building_info">
                            <div className="item_info">
                                <p className="txt_info title_info">사업자명</p>
                                <p className="txt_info code_info">{businessName === null ? "없음" : businessName}</p>
                            </div>
                        </div>
                        <button class="btn_contr btn_add" onClick={openModal}>검색</button>
                    </div>
                </div>
            </div>

            {isModalOpen && <Modal closeModal={closeModal} getData={getData} />}
        </>
    );
};

const Modal = ({ closeModal, getData }) => {
    const { id } = useParams();
    const [dataSource, setDataSource] = useState([]);
    const [checkedBusiness, setCheckedBusiness] = useState(null);

    useEffect(() => {
        apiWrapper(async () => {
            const { status, data } = await fireonApi.getBusinessUserList();
            if (status === true) {
                setDataSource(data);
            } else {
                alert(`${data}`);
            }
        })
    }, []);

    const handleChangeCheck = (e, business) => {
        if (checkedBusiness === business) {
            if (e.target.checked === false) {
                setCheckedBusiness(null);
            }
        } else {
            setCheckedBusiness(business);
        }
    };


    const handleSave = () => {
        const message = checkedBusiness === null ? `사업자 설정을 해제하시겠습니까?` : `선택하신 사업자(${checkedBusiness.businessName})로 설정하시겠습니까?`;
        if (window.confirm(message))
            apiWrapper(async () => {
                const requestBody = {
                    "businessId": checkedBusiness === null ? null : checkedBusiness.id
                };
                const { status, data } = await fireonApi.setFireFightingObjectBusinessUser(id, requestBody);
                alert(`${data}`);

                if (status === true) {
                    //성공 시 새로고침
                    closeModal();
                    getData();
                }
            })
    }

    return (
        <div id="modal" class="modal rightModal noticeRightModal open"
            onClick={(e) => {
                if (e.target === e.currentTarget)
                    closeModal();
            }}>
            <div class="modal_content">
                <button type="button" class="close_modal" onClick={closeModal}>
                    <i class="x-icon close_icon"></i>
                </button>
                <h2>모니터링 관리 사업자 선택</h2>
                <div class="tableBoard businessUserListTableBoard">
                    <div class="table_board scroll_board">
                        <div className="wrap_table wrap_small_table">
                            <div className="containerTable ">
                                <ul className="head_table">
                                    <li><p>선택</p></li>
                                    <li><p>관리ID</p></li>
                                    <li><p>상호명</p></li>
                                </ul>
                                <div className="body_table">
                                    <div className="inner_table_wrap">
                                        {dataSource &&
                                            dataSource.map((item, index) => (
                                                <div className="wrap_table_item" key={index}>
                                                    <div className="inner_table_item table_item_01">
                                                        <input className="cont_table_chekbox" type="checkbox" checked={checkedBusiness === item} onChange={(e) => handleChangeCheck(e, item)} />
                                                    </div>
                                                    <div className="inner_table_item table_item_02">
                                                        <p className="cont_table_item">{item.id}</p>
                                                    </div>
                                                    <div className="inner_table_item table_item_03">
                                                        <p className="cont_table_item">{item.businessName}</p>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn_dark" onClick={handleSave}>저장</button>
                </div>
            </div>
        </div>
    )
}